import React from 'react'
import './NewBieMenu.css';
import ChangeLink from "../../../Elements/ChangeLink/ChangeLink";

function NewBieMenu(props) {
        return (
            <div className="NewBieMenu">
                <ChangeLink lang={props.lang} to='/contests/join/championship'  className={props.ActiveLink[0]}>
                        <div className="NewBieMenuElementText">Contest information</div>
                </ChangeLink>
                <ChangeLink lang={props.lang} to='/contests/current-results' className={props.ActiveLink[1]}>
                        <div className="NewBieMenuElementText">Current Results</div>
                </ChangeLink>
            </div>
)}
export default NewBieMenu








